import NavMenuDesktop from './NavMenuDesktop';

export default NavMenuDesktop;
